import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { useMemo } from 'react';
import isUndefined from 'lodash/isUndefined';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio as MuiRadio, RadioGroup as MuiRadioGroup, Typography, Collapse, IconButton } from '@material-ui/core';
import { ExpandLess, ExpandMore, RadioButtonUncheckedOutlined as RadioButtonUncheckedOutlinedIcon, RadioButtonCheckedOutlined as RadioButtonCheckedOutlinedIcon } from '@material-ui/icons';
import { getColumnsStyles } from './CheckboxGroup';
import classnames from 'classnames';

var renderFormGroup = function renderFormGroup(ID, value, onChange, field, classes, isColumns, disabled, slim) {
  return React.createElement(MuiRadioGroup, {
    row: true,
    "aria-label": 'Gender',
    name: 'gender1',
    value: value,
    onChange: onChange
  }, React.createElement("div", {
    style: isColumns ? getColumnsStyles(field.columns) : undefined
  }, !isUndefined(field.items) ? field.items.map(function (item, index) {
    return React.createElement(FormControlLabel, {
      key: index,
      label: item.label,
      className: classnames(classes.checkGroupControlLabel, isColumns ? classes.checkGroupColumnControlLabel : ''),
      classes: {
        label: classnames(_defineProperty({}, classes.slimCheckLabel, !!slim))
      },
      value: String(item.value),
      control: React.createElement(MuiRadio, {
        id: "".concat(ID, "_").concat(index),
        className: classes.checkGroupControl,
        color: 'primary',
        // в chrome появляется баг с колонками при условии полного заполнения колонок элементами,
        // когда при клике на первый элемент 2й и следующих колонок с transition,
        // этот элемент съезжает на следующую колонку
        // https://bugs.chromium.org/p/chromium/issues/detail?id=460222
        disableRipple: isColumns,
        disabled: disabled,
        icon: React.createElement(RadioButtonUncheckedOutlinedIcon, {
          fontSize: slim ? 'small' : 'default'
        }),
        checkedIcon: React.createElement(RadioButtonCheckedOutlinedIcon, {
          fontSize: slim ? 'small' : 'default'
        }),
        classes: {
          root: slim ? classes.slimCheckControl : classes.baseCheckControl
        }
      })
    });
  }) : null));
};

export default function RadioGroup(props) {
  var id = props.id,
      required = props.required,
      field = props.field,
      value = props.value,
      error = props.error,
      onFieldChange = props.onFieldChange,
      classes = props.classes,
      disabled = props.disabled,
      slim = props.slim;
  var ID = id || field.name;
  var isColumns = !!field.columns;
  var isCollapse = 'collapse' in field;
  /** Устанавливаемое значение*/

  var selectedValue = useMemo(function () {
    return !isUndefined(value) ? String(value) : '';
  }, [value]);

  var _React$useState = React.useState(isCollapse ? !field.collapse : true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      opened = _React$useState2[0],
      setOpened = _React$useState2[1];

  var onChange = function onChange(event, componentValue) {
    onFieldChange(ID, event.target.value || componentValue);
  };
  /**
   * Открытие/скрытие группы
   */


  var toggleOpened = function toggleOpened() {
    setOpened(!opened);
  };

  var formGroupComponent = renderFormGroup(ID, selectedValue, onChange, field, classes, isColumns, disabled, slim);
  return React.createElement(FormControl, {
    required: !!required,
    error: !!error,
    component: 'fieldset'
  }, React.createElement(FormLabel, {
    component: 'legend',
    classes: {
      root: classes.checkGroupLabel,
      focused: classes.checkGroupLabelFocused
    }
  }, React.createElement(Typography, {
    variant: slim ? 'body2' : 'body1',
    display: 'inline'
  }, field.label, isCollapse && React.createElement(IconButton, {
    onClick: toggleOpened,
    size: 'small',
    edge: 'end'
  }, opened ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null)))), isCollapse ? React.createElement(Collapse, {
    in: opened
  }, formGroupComponent) : formGroupComponent, !!error && React.createElement(FormHelperText, {
    className: classnames(_defineProperty({}, classes.slimHelperText, !!slim))
  }, error));
}